import { toRaw } from 'vue';

import { conversationSubscriptionService } from '~/services/conversation-subscription-service';

export default {
  install(app) {
    // Access realtime from the app's provide context after it's been registered
    const originalMount = app.mount;

    app.mount = function (...args) {
      // Get realtime from the app's _context.provides after all plugins are registered
      const realtime = app._context.provides.realtime;

      if (realtime) {
        conversationSubscriptionService.init(toRaw(realtime));
      } else {
        console.error('[ConversationSubscriptionPlugin] realtime not found in provides');
      }

      app.provide('conversationSubscriptionService', conversationSubscriptionService);

      return originalMount.apply(this, args);
    };
  },
};
